import { Component, EventEmitter, Input, Output } from '@angular/core';

// Sequential corrections trail for a transaction (and, on a correction, the
// backlink to the transaction it corrects). Shared by detail-transaction and
// detail-view's 'corrections' field type; hosts handle navigation via (open).
@Component({
  selector: 'app-correction-list',
  templateUrl: './correction-list.component.html',
  styleUrls: ['./correction-list.component.scss']
})
export class CorrectionListComponent {
  @Input('corrections') corrections: any[] = [];
  @Input('correctionFor') correctionFor: any = null;
  @Input('type') type = '';
  @Input('divisor') divisor = 1;
  @Output('open') open = new EventEmitter<string>();

  get isMoney(): boolean {
    return this.type !== 'inventory';
  }

  display(raw: number): string {
    if (raw == null) { return '—'; }
    const divisor = this.divisor || 1;
    if (this.isMoney) {
      const value = -raw / divisor;
      return (value < 0 ? '-' : '') + '$' + Math.abs(value).toFixed(2);
    }
    const qty = raw / divisor;
    return (qty > 0 ? '+' : '') + qty;
  }
}
